var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isVisible,
      expression: "isVisible"
    }],
    staticClass: "cabinet-notification"
  }, [_vm.userProjectIsInactive ? [_c('notification', {
    attrs: {
      "color-overlay": "#ff5172"
    }
  }, [_c('p', [_c('span', {
    attrs: {
      "data-blocked-title": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('project.blocked')))]), _vm._v(" " + _vm._s(_vm.$t('payments.intake.and.payouts.unavailable')) + " "), _c('span', {
    attrs: {
      "data-blocked-link": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('contact.to.support', {
        projectName: _vm.PROJECT_INFO.name
      }))
    }
  })])])] : _vm.isNeedIdentification ? [_vm.isAwaitingModification ? [_c('notification', {
    attrs: {
      "color-overlay": "#ff5172"
    }
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('clarification.identification.data'))
    }
  }), _c('a', {
    staticClass: "button thin clear",
    attrs: {
      "slot": "button",
      "target": "_blank"
    },
    on: {
      "click": _vm.goToIdentity
    },
    slot: "button"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('fill.form')))])])])] : [_c('notification', [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('raise.limits.and.remove.restrictions'))
    }
  }), _c('a', {
    staticClass: "button thin clear",
    attrs: {
      "slot": "button",
      "target": "_blank"
    },
    on: {
      "click": _vm.goToIdentity
    },
    slot: "button"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('fill.form')))])])])]] : _vm.isShowSelfEmployedBindingNotification ? [_c('notification', {
    attrs: {
      "color-overlay": "#9B51E0",
      "image-overlay": "self-employed"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('confirm.self.employed.status')))]), _c('router-link', {
    staticClass: "button thin clear",
    attrs: {
      "slot": "button",
      "to": {
        name: 'selfEmployed'
      }
    },
    slot: "button"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('turn.on.self.employed')))])])], 1)] : _vm.projectPaymentsDisabled ? [_c('notification', [_c('p', [_c('strong', {
    domProps: {
      "textContent": _vm._s(_vm.$t('notification.payment.disabled.title'))
    }
  }), _vm._v(" " + _vm._s(_vm.$t('notification.payment.disabled.message')) + " ")]), _c('a', {
    staticClass: "button thin clear",
    attrs: {
      "slot": "button",
      "href": "https://help.capusta.space/contact_us",
      "target": "_blank"
    },
    slot: "button"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('notification.payment.disabled.submit')))])])])] : !_vm.projectValidated ? [_c('notification', [_c('p', [_c('strong', {
    domProps: {
      "textContent": _vm._s(_vm.$t('notification.project.moderation.title'))
    }
  }), _vm._v(" " + _vm._s(_vm.displayLimitAmountMessage) + " ")]), _c('a', {
    staticClass: "button thin clear",
    attrs: {
      "slot": "button",
      "href": "https://help.capusta.space/control",
      "target": "_blank"
    },
    slot: "button"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('notification.project.moderation.submit')))])])])] : _vm._e()], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }